import { useTranslation } from 'react-i18next'
import SimpleButton from '../../../common/SimpleButton'
import PageModal from '../../../common/PageModal'
import GenericTable from '../../../common/GenericTable'
import '../../internal-reports.scss'

const ViewRemoteAccessModal = (props) => {
  const { t } = useTranslation()
  const { tableData, rowId, closeModal } = props
  const selectedRecord = tableData.find((record) => record.id === rowId)
  const userFooterContent = () => {
    return (
      <>
        <SimpleButton className="cancel-button" onClick={closeModal}>
          {t('close')}
        </SimpleButton>
      </>
    )
  }

  return (
    <>
      <PageModal toggle onToggle={closeModal} className="device-modal" title={t('details')} footerContent={userFooterContent()}>
        <div className="registered-devices-modal-content">
          <div className="section-title">{t('general_information').toUpperCase()}</div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('date')}</p>
              <div className="value">{selectedRecord.date}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('model')}</p>
              <div className="value">{selectedRecord.originalModel ? selectedRecord.model : 'Unknown'}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('coltene_store.cart.total')}</p>
              <div className="value">{selectedRecord.total}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('account_context.account_type')}</p>
              <div className="value">{selectedRecord.accountType}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('reports.user_group')}</p>
              <div className="value">{t(`register.${selectedRecord.userGroup}`)}</div>
            </div>
            <div className="input-wrapper"></div>
          </div>

          <div className="separator" />

          <div className="section-title">{t('countries').toUpperCase()}</div>
          <div className="row-wrapper">
            <GenericTable
              className="countries-table"
              data={selectedRecord.countries}
              headers={[
                { title: t('country') },
                { title: t('coltene_store.cart.total') },
                { title: '' },
              ]}
              keys={['name', 'total', '']}
            />
          </div>
        </div>
      </PageModal>
    </>
  )
}

export default ViewRemoteAccessModal

